'use es6';

import { Panel } from 'foundations-components/transitional/components/Panel';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledUniversalSidebarPanel = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Panel, {
    width: 477,
    children: children
  });
};
export default StyledUniversalSidebarPanel;